/*
 * cart-bundle.js — Duckiewonderland centrale cart-controller
 */
(function () {
  'use strict';

  var STALE_DRAWER_SECTION = 'sections--17276519416017__cart-drawer';
  var _fetch = window.fetch.bind(window);
  var lastPointer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawerSectionId() {
    var d = document.querySelector('cart-drawer');
    var w = d && d.closest('.shopify-section');
    if (w && w.id) return w.id.replace('shopify-section-', '');
    return STALE_DRAWER_SECTION;
  }

var _cartCache = null, _cartCacheAt = 0, _cartInflight = null;
  var CART_TTL = 1000;

  function invalidateCart() { _cartCache = null; _cartCacheAt = 0; }

  function getCart(force) {
    if (!force && _cartCache && (Date.now() - _cartCacheAt) < CART_TTL) {
      return Promise.resolve(_cartCache);
    }
    if (!force && _cartInflight) return _cartInflight;
    _cartInflight = _fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { _cartCache = c; _cartCacheAt = Date.now(); _cartInflight = null; return c; })
      .catch(function (e) { _cartInflight = null; throw e; });
    return _cartInflight;
  }
  
  function updateCart(updates) {
    return _fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function (j) { invalidateCart(); return j; });
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }
  function openDrawer() {
    var d = drawerEl(); if (!d) return;
    if (typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
    d.classList.add('active'); d.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;
    if (typeof d.close === 'function') { try { d.close(); return; } catch (e) {} }
    d.classList.remove('active'); d.setAttribute('aria-hidden', 'true');
  }

  function mainCartSectionId() {
    var mc = document.querySelector('.main-cart'); if (!mc) return null;
    var wrap = mc.closest('.shopify-section'); if (!wrap || !wrap.id) return null;
    return wrap.id.replace('shopify-section-', '');
  }

  // pre.sections: al gerenderde secties (uit het antwoord van /cart/add.js).
  // Scheelt een hele netwerkronde. Zonder pre wordt er alsnog opgehaald.
  function refreshCartUI(openAfter, pre) {
    var did = drawerSectionId();
    var ids = [did];
    var mcId = mainCartSectionId();
    if (mcId) ids.push(mcId);

    var sectionsP = (pre && pre.sections)
      ? Promise.resolve(pre.sections)
      : _fetch(root() + '?sections=' + encodeURIComponent(ids.join(',')))
          .then(function (r) { return r.json(); });

    return Promise.all([sectionsP, getCart(true)]).then(function (res) {
      var sections = res[0] || {};
      var cart = res[1] || {};
      var openNow = false;

      var dHtml = sections[did];
      if (dHtml) {
        var doc = new DOMParser().parseFromString(dHtml, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var current = drawerEl();
        var wasOpen = current && current.classList.contains('active');
        if (fresh && current && current.parentNode) {
          current.parentNode.replaceChild(fresh, current);
          openNow = !!(openAfter || wasOpen);
        }
      }
      if (mcId && sections[mcId] != null) {
        var wrapEl = document.getElementById('shopify-section-' + mcId);
        if (wrapEl) wrapEl.innerHTML = sections[mcId];
      }

      // Alles wat de inhoud vormgeeft gebeurt VOORDAT de drawer opengaat.
      // Daardoor bestaat de ongegroepeerde tussenstand nooit op het scherm.
      markBundleRowsWith(cart);
      neutralizeRemoveLinks();
      revealDrawerImages();
      prettifyBundleTags();
      groupBundlesWith(cart);
      enhanceEmptyCart();

      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      fixCountLabel(cart.item_count);

      if (openNow) openDrawer();
    });
  }

  function fixCountLabel(n) {
    var p = document.querySelector('.main-cart .cart-header-count');
    if (!p) return;
    if (n == null) { var s = p.querySelector('.cart-count'); n = s ? (parseInt(s.textContent, 10) || 0) : 0; }
    p.innerHTML = '<span class="cart-count">' + n + '</span> ' + (n === 1 ? ((window.DWL_I18N && window.DWL_I18N.item) || 'item') : ((window.DWL_I18N && window.DWL_I18N.items) || 'items'));
  }

  function updateCartCount() {
    return getCart().then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      fixCountLabel(cart.item_count);
      return cart;
    }).catch(function () {});
  }

  // Synchrone variant: gebruikt een cart die we al hebben, geen extra netwerkronde.
  function markBundleRowsWith(cart) {
    var rows = document.querySelectorAll('.cart-product[data-item-key]');
    if (!rows.length) return;
    var bundleKeys = {};
    var giftKeys = {};
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._bundle_id) { bundleKeys[it.key] = true; }
      else if (it.final_price === 0) { giftKeys[it.key] = true; }
    });
    rows.forEach(function (row) {
      var k = row.getAttribute('data-item-key');
      row.setAttribute('data-bundle', bundleKeys[k] ? '1' : '0');
      if (giftKeys[k]) { row.setAttribute('data-free-gift', '1'); } else { row.removeAttribute('data-free-gift'); }
    });
  }

  function markBundleRows() {
    var rows = document.querySelectorAll('.cart-product[data-item-key]');
    if (!rows.length) return;
    getCart().then(markBundleRowsWith).catch(function () {});
  }

  function neutralizeRemoveLinks(scopeEl) {
    var scope = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;
    var links = scope.querySelectorAll('a.cart-product-remove');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.parentNode) continue;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = a.className;
      btn.innerHTML = a.innerHTML;
      btn.setAttribute('aria-label', (a.textContent || 'Remove').trim() || 'Remove');
      btn.style.cursor = 'pointer';
      a.parentNode.replaceChild(btn, a);
    }
  }

  function revealDrawerImages() {
    document.querySelectorAll('cart-drawer .lazy-loading-image--main, .main-cart .lazy-loading-image--main').forEach(function (img) {
      img.loading = 'eager';
      if (!(img.complete && img.naturalWidth > 0)) { var src = img.getAttribute('src'); if (src) img.setAttribute('src', src); }
    });
  }

  function enhanceEmptyCart() {
    var mc = document.querySelector('.main-cart');
    if (!mc) return;
    var container = mc.querySelector('.section-main-cart-container');
    if (!container) return;
    if (mc.querySelector('.cart-form') || mc.querySelector('.cart-product')) return;
    if (mc.querySelector('.dwl-empty-cart')) return;
    var kids = container.children;
    for (var i = 0; i < kids.length; i++) { if (kids[i].tagName === 'P') { kids[i].remove(); break; } }
    var block = document.createElement('div');
    block.className = 'dwl-empty-cart';
    block.innerHTML =
      '<div class="dwl-empty-emoji">🦆</div>' +
      '<p class="dwl-empty-text">Your cart is empty</p>' +
      '<a href="/collections/all" class="dwl-empty-btn">Continue shopping</a>';
    container.appendChild(block);
  }

  function dwlBundleLabel() { return (window.DWL_I18N && window.DWL_I18N.bundleDeal) || 'Bundle deal'; }
  function dwlForWord() { return (window.DWL_I18N && window.DWL_I18N.forWord) || 'for'; }

  function prettifyBundleTags() {
    var spans = document.querySelectorAll('.cart-product-discounts-list-item__title > span, .cart-totals-discounts-list-item > span');
    for (var i = 0; i < spans.length; i++) {
      var sp = spans[i];
      if (sp.getAttribute('data-dwl-pretty') === '1') continue;
      var txt = (sp.textContent || '').trim();
      var m = txt.match(/\((\d+)\s*for\s*([\d.,]+)\)/i);
      if (m) {
        sp.textContent = dwlBundleLabel() + ' · ' + m[1] + ' ' + dwlForWord() + ' €' + m[2].replace('.', ',');
        sp.setAttribute('data-dwl-pretty', '1');
      } else if (/bundle[-\s]?deal/i.test(txt)) {
        sp.textContent = dwlBundleLabel();
        sp.setAttribute('data-dwl-pretty', '1');
      }
    }
  }

  // ---------- Bundel-groepering (ducks naast elkaar in 1 card) ----------
  var _grouping = false;
  function fmtMoney(cents) { return '€' + (Math.round(cents) / 100).toFixed(2).replace('.', ','); }
  function esc(str) {
    return (str == null ? '' : String(str)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function prettyDealLabel(title) {
    if (!title) return 'Bundle';
    var m = title.match(/\((\d+)\s*for\s*([\d.,]+)\)/i);
    if (m) return dwlBundleLabel() + ' · ' + m[1] + ' ' + dwlForWord() + ' €' + m[2].replace('.', ',');
    if (/bundle[-\s]?deal/i.test(title)) return dwlBundleLabel();
    return title;
  }

  // "Full set" family-deals: de hele-collectie packs (7-packs). Eigen naam + GEEN Change-knop.
  var FAMILY_DEALS = {
    'crypto-bundle-deal': { '7': 'Crypto Ducks Family Deal' },
    'jurassic-bundle-deal': { '7': 'Jurassic Ducks Family Deal' },
    'mix-match-1500': { '7': 'Jurassic Ducks Family Deal' }
  };
  function familyDealName(handle, tier) {
    var m = FAMILY_DEALS[handle];
    return (m && m[String(tier)]) || null;
  }

  function buildBundleCard(bid, items, mode) {
    var origTotal = 0, finalTotal = 0, label = 'Bundle', disc = null;
    items.forEach(function (it) {
      origTotal += (it.original_line_price != null ? it.original_line_price : it.line_price);
      finalTotal += (it.final_line_price != null ? it.final_line_price : it.line_price);
      if (!disc && it.line_level_discount_allocations && it.line_level_discount_allocations[0]) {
        disc = it.line_level_discount_allocations[0].discount_application.title;
      }
    });
    if (disc) label = prettyDealLabel(disc);
    var saving = origTotal - finalTotal;
    var handle = (items[0].properties && items[0].properties._bundle) || '';
    var tier = (items[0].properties && items[0].properties._bundle_tier) || '';
    var famName = familyDealName(handle, tier);
    if (famName) label = famName;
    var thumbs = items.map(function (it) {
      var q = parseInt(it.quantity, 10) || 1;
      return '<span class="dwl-bundle-thumb" title="' + esc(it.title) + (q > 1 ? ' \u00d7' + q : '') + '">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="eager">' : '') +
        (q > 1 ? '<i class="dwl-bundle-qty">' + q + '</i>' : '') +
      '</span>';
    }).join('');
    var inner =
      '<div class="dwl-bundle-head">' +
        '<span class="dwl-bundle-badge">' + esc(label) + '</span>' +
        (saving > 0 ? '<span class="dwl-bundle-save">save ' + fmtMoney(saving) + '</span>' : '') +
      '</div>' +
      '<div class="dwl-bundle-thumbs">' + thumbs + '</div>' +
      '<div class="dwl-bundle-foot">' +
        '<div class="dwl-bundle-price">' + (saving > 0 ? '<s>' + fmtMoney(origTotal) + '</s> ' : '') + '<b>' + fmtMoney(finalTotal) + '</b></div>' +
        '<div class="dwl-bundle-actions">' +
          (famName ? '' : '<button type="button" class="dwl-bundle-change">Change</button>') +
          '<button type="button" class="cart-product-remove dwl-bundle-remove">Remove bundle</button>' +
        '</div>' +
      '</div>';
    var el;
    if (mode === 'cart') {
      el = document.createElement('tr');
      el.innerHTML = '<td colspan="5" class="dwl-bundle-cell">' + inner + '</td>';
    } else {
      el = document.createElement('li');
      el.innerHTML = inner;
    }
    el.className = 'cart-product dwl-bundle-card';
    el.setAttribute('data-dwl-bundle-id', bid);
    el.setAttribute('data-item-key', items[0].key);
    el.setAttribute('data-bundle', '1');
    el.setAttribute('data-bundle-handle', handle);
    el.setAttribute('data-bundle-tier', tier);
    el.setAttribute('data-product-url', (items[0].url) || '');
    if (famName) el.setAttribute('data-family', '1');
    return el;
  }

  function groupContainer(container, mode, cart) {
    var groups = {};
    (cart.items || []).forEach(function (it) {
      var bid = it.properties && it.properties._bundle_id;
      if (bid) { (groups[bid] = groups[bid] || []).push(it); }
    });
    Object.keys(groups).forEach(function (bid) {
      var items = groups[bid];
      var qtyTotal = items.reduce(function (s, it) { return s + (parseInt(it.quantity, 10) || 1); }, 0);
      if (qtyTotal < 2) return;
      if (container.querySelector('.dwl-bundle-card[data-dwl-bundle-id="' + bid + '"]')) return;
      var rows = [];
      items.forEach(function (it) {
        var r = container.querySelector('.cart-product[data-item-key="' + it.key + '"]:not(.dwl-bundle-card)');
        if (r) rows.push(r);
      });
      if (!rows.length) return;
      var card = buildBundleCard(bid, items, mode);
      rows[0].parentNode.insertBefore(card, rows[0]);
      rows.forEach(function (r) { r.remove(); });
    });
  }

  // Synchrone variant: groepeert meteen met een cart die we al hebben.
  function groupBundlesWith(cart) {
    var drawer = document.querySelector('cart-drawer .cart-drawer-products');
    var cartList = document.querySelector('.main-cart .cart-contents-products-list');
    if (!drawer && !cartList) return;
    if (drawer) groupContainer(drawer, 'drawer', cart);
    if (cartList) groupContainer(cartList, 'cart', cart);
    stabilizeDrawer();
    prewarmPickers();
  }

  function groupBundles() {
    if (_grouping) return;
    var drawer = document.querySelector('cart-drawer .cart-drawer-products');
    var cartList = document.querySelector('.main-cart .cart-contents-products-list');
    if (!drawer && !cartList) return;
    _grouping = true;
    getCart().then(function (cart) {
      if (drawer) groupContainer(drawer, 'drawer', cart);
      if (cartList) groupContainer(cartList, 'cart', cart);
    }).catch(function () {}).then(function () { _grouping = false; stabilizeDrawer(); prewarmPickers(); });
  }

  // Anti-flash: zodra er ooit een bundel-card in de drawer verscheen, markeren we de drawer
  // als 'stabilized'. De CSS verbergt dan losse producten met een bundel-kortingtag, zodat
  // de korte ongegroepeerde tussenstaat (bij de tweede render) nooit zichtbaar wordt.
  function stabilizeDrawer() {
    var d = drawerEl();
    if (!d) return;
    var list = d.querySelector('.cart-drawer-products');
    if (!list) return;
    // Class op <html> (niet op de drawer): de drawer wordt bij een refresh vervangen,
    // dus een class daarop zou verdwijnen en de flash weer zichtbaar maken.
    if (list.querySelector('.dwl-bundle-card')) {
      document.documentElement.classList.add('dwl-cart-stabilized');
    } else if (!list.querySelector('.cart-product:not(.dwl-bundle-card)[data-bundle]:not([data-bundle="0"]):not([data-bundle=""])')) {
      // Geen bundel-card en geen losse bundel-items meer -> reset, zodat niets onterecht verborgen blijft.
      document.documentElement.classList.remove('dwl-cart-stabilized');
    }
  }

  var _injectedPickers = {};
  var _pickerPromises = {};
  var _pickerStyleInjected = false;
  function ensureLocalPicker(intent) {
    var handle = intent.handle;
    var existing = handle ? document.querySelector('.bundle-deal-card[data-bundle-handle="' + handle + '"]') : null;
    if (existing) return Promise.resolve(existing);
    if (handle && _injectedPickers[handle] && _injectedPickers[handle].isConnected) return Promise.resolve(_injectedPickers[handle]);
    if (handle && _pickerPromises[handle]) return _pickerPromises[handle];
    var url = (intent.items[0] && intent.items[0].url) || null;
    if (!url) return Promise.resolve(null);
    var pr = new Promise(function (resolve) {
      _fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = (handle && doc.querySelector('.bundle-deal-card[data-bundle-handle="' + handle + '"]')) || doc.querySelector('.bundle-deal-card');
        if (!card) { resolve(null); return; }
        var host = document.getElementById('dwl-picker-host');
        if (!host) { host = document.createElement('div'); host.id = 'dwl-picker-host'; host.style.display = 'none'; document.body.appendChild(host); }
        if (!_pickerStyleInjected) {
          var style = Array.prototype.slice.call(doc.querySelectorAll('style')).filter(function (x) { return x.textContent.indexOf('.bundle-deal-modal') !== -1; })[0];
          if (style) { var st = document.createElement('style'); st.textContent = style.textContent; document.head.appendChild(st); }
          _pickerStyleInjected = true;
        }
        host.appendChild(card);
        var script = Array.prototype.slice.call(doc.querySelectorAll('script')).filter(function (x) { return x.textContent.indexOf('bootBundleDealCards') !== -1; })[0];
        if (script) { var sc = document.createElement('script'); sc.textContent = script.textContent; document.body.appendChild(sc); }
        if (handle) _injectedPickers[handle] = card;
        setTimeout(function () { resolve(card); }, 120);
      }).catch(function () { if (handle) delete _pickerPromises[handle]; resolve(null); });
    });
    if (handle) _pickerPromises[handle] = pr;
    return pr;
  }

  function prewarmPickers() {
    var run = function () {
      document.querySelectorAll('.dwl-bundle-card[data-product-url]:not([data-family="1"])').forEach(function (card) {
        var handle = card.getAttribute('data-bundle-handle');
        var url = card.getAttribute('data-product-url');
        if (!handle || !url) return;
        if (_injectedPickers[handle] || _pickerPromises[handle] || document.querySelector('.bundle-deal-card[data-bundle-handle="' + handle + '"]')) return;
        ensureLocalPicker({ handle: handle, items: [{ url: url }] });
      });
    };
    if ('requestIdleCallback' in window) { requestIdleCallback(run, { timeout: 2000 }); } else { setTimeout(run, 400); }
  }

  function openPickerWithSelection(picker, intent) {
    if (!picker || !intent) return false;
    var tier = String(intent.tier || '');
    var tierBtn = picker.querySelector('.bundle-deal-tier[data-tier-qty="' + tier + '"]:not(.bundle-deal-tier--single)')
      || picker.querySelector('.bundle-deal-tier:not(.bundle-deal-tier--single)');
    if (!tierBtn) return false;
    var modal = picker.querySelector('[data-modal]');
    try { tierBtn.click(); } catch (e) { return false; }
    var scope = modal || document;
    var items = (intent.items || []).slice();
    if (!items.length) return true;
    var search = scope.querySelector('[data-picker-search]');
    function grid() { return scope.querySelector('[data-picker-grid]'); }
    function strip() { return scope.querySelector('[data-selection-strip]'); }
    function tileFor(id) { var g = grid(); return g && g.querySelector('.bundle-deal-picker-item[data-variant-id="' + id + '"]'); }

    function clearAll(done) {
      var guard = 0;
      (function loop() {
        var s = strip();
        var chip = s && s.querySelector('.bundle-deal-selchip');
        if (chip && guard++ < 60) { chip.click(); setTimeout(loop, 12); }
        else { done(); }
      })();
    }

    function selectOne(item, done) {
      if (search) { search.value = item.title || ''; search.dispatchEvent(new Event('input', { bubbles: true })); }
      var tries = 0;
      (function wait() {
        var tile = tileFor(item.id);
        if (tile) {
          var q = item.quantity || 1;
          for (var k = 0; k < q; k++) { tile.click(); }
          done();
        } else if (tries++ < 30) { setTimeout(wait, 120); }
        else { done(); }
      })();
    }

    var startTries = 0;
    (function waitReady() {
      var g = grid();
      var ready = g && g.querySelector('.bundle-deal-picker-item');
      if (ready || startTries++ > 40) {
        clearAll(function () {
          var idx = 0;
          (function next() {
            if (idx >= items.length) {
              if (search) { search.value = ''; search.dispatchEvent(new Event('input', { bubbles: true })); }
              return;
            }
            selectOne(items[idx++], next);
          })();
        });
      } else { setTimeout(waitReady, 120); }
    })();
    return true;
  }

  function buildEditIntent(card, cart) {
    var bid = card.getAttribute('data-dwl-bundle-id');
    var handle = card.getAttribute('data-bundle-handle') || '';
    var tier = card.getAttribute('data-bundle-tier') || '';
    var items = (cart.items || []).filter(function (it) { return it.properties && it.properties._bundle_id === bid; })
      .map(function (it) { return { id: it.variant_id || it.id, title: it.product_title || it.title, image: it.image, quantity: it.quantity, url: it.url }; });
    return { handle: handle, tier: tier, items: items };
  }

  var _changing = false;
  var _replace = null;
  function handleChangeBundle(card) {
    if (!card || _changing) return;
    _changing = true;
    getCart().then(function (cart) {
      var intent = buildEditIntent(card, cart);
      var bid = card.getAttribute('data-dwl-bundle-id');
      var oldKeys = (cart.items || []).filter(function (it) { return it.properties && it.properties._bundle_id === bid; })
        .map(function (it) { return it.key; });
      ensureLocalPicker(intent).then(function (picker) {
        _changing = false;
        if (!picker) return;
        openPickerWithSelection(picker, intent);
        _replace = { keys: oldKeys };
      });
    }).catch(function () { _changing = false; });
  }

  var _removing = false;
  function doBundleRemove(targetEl) {
    var card = targetEl && targetEl.closest ? targetEl.closest('.dwl-bundle-card') : null;
    var directBid = card ? card.getAttribute('data-dwl-bundle-id') : null;
    var row = targetEl && targetEl.closest ? targetEl.closest('.cart-product') : null;
    var itemKey = row ? row.getAttribute('data-item-key') : null;
    if (!directBid && !itemKey) return;
    if (_removing) return;
    _removing = true;
    getCart().then(function (cart) {
      var updates = {};
      if (directBid) {
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._bundle_id === directBid) updates[it.key] = 0;
        });
      } else {
        var clicked = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === itemKey) { clicked = cart.items[i]; break; }
        }
        var bundleId = clicked && clicked.properties ? clicked.properties._bundle_id : null;
        if (bundleId) {
          cart.items.forEach(function (it) {
            if (it.properties && it.properties._bundle_id === bundleId) updates[it.key] = 0;
          });
        } else {
          updates[itemKey] = 0;
        }
      }
      return updateCart(updates);
    }).then(function () {
      return refreshCartUI(false);
    }).catch(function (e) { console.error('[DWLCart] remove', e); })
      .then(function () { _removing = false; });
  }

  function removeInterceptor(event) {
    var btn = event.target && event.target.closest ? event.target.closest('.cart-product-remove') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.type === 'pointerdown' || event.type === 'click') { doBundleRemove(event.target); }
  }

  function cartTarget() {
    return document.querySelector(
      '.section-header-cart-drawer-toggle, .header-cart-icon, [data-cart-icon], .cart-icon, a[href$="/cart"]'
    );
  }

  function flyToCart(qty, origin) {
    try {
      var target = cartTarget();
      if (!target) return;
      var tr = target.getBoundingClientRect();
      var tx = tr.left + tr.width / 2;
      var ty = tr.top + tr.height / 2;
      var start = (origin && typeof origin.x === 'number')
        ? { left: origin.x, top: origin.y }
        : { left: window.innerWidth / 2, top: window.innerHeight / 2 };

      var visible = Math.min(qty, 6);
      for (var i = 0; i < visible; i++) {
        (function (idx) {
          var duck = document.createElement('div');
          duck.className = 'dwl-fly-duck';
          duck.textContent = '🦆';
          duck.style.left = start.left + 'px';
          duck.style.top = start.top + 'px';
          document.body.appendChild(duck);
          requestAnimationFrame(function () {
            setTimeout(function () {
              duck.style.transform =
                'translate(' + (tx - start.left) + 'px,' + (ty - start.top) + 'px) scale(0.3) rotate(20deg)';
              duck.style.opacity = '0.15';
            }, idx * 90);
          });
          setTimeout(function () { if (duck.parentNode) duck.remove(); }, 800 + idx * 90);
        })(i);
      }

      if (qty > 6) showCountBurst(tr, qty);
      setTimeout(function () { pulseCartIcon(target); }, 350);
    } catch (e) {}
  }

  function showCountBurst(tr, qty) {
    var badge = document.createElement('div');
    badge.className = 'dwl-count-burst';
    badge.textContent = '+' + qty;
    badge.style.left = (tr.left + tr.width / 2) + 'px';
    badge.style.top = tr.top + 'px';
    document.body.appendChild(badge);
    setTimeout(function () { if (badge.parentNode) badge.remove(); }, 1200);
  }

  function pulseCartIcon(target) {
    target.classList.add('dwl-cart-pulse');
    setTimeout(function () { target.classList.remove('dwl-cart-pulse'); }, 600);
  }

  // ---------- Picker-images: eerste rij eager, rest progressief (cap) op de achtergrond ----------
  var PRELOAD_MAX = 80;
  var _preloadQueue = [];
  var _preloading = false;
  var _preloaded = {};
  function preloadUrls(urls) {
    var added = false;
    for (var i = 0; i < urls.length; i++) {
      var u = urls[i];
      if (u && !_preloaded[u]) { _preloaded[u] = 1; _preloadQueue.push(u); added = true; }
    }
    if (!added || _preloading) return;
    _preloading = true;
    (function pump() {
      if (!_preloadQueue.length) { _preloading = false; return; }
      var batch = _preloadQueue.splice(0, 4);
      batch.forEach(function (u) { var im = new Image(); im.decoding = 'async'; im.src = u; });
      setTimeout(pump, 120);
    })();
  }
  function boostPickerImages() {
    var grids = document.querySelectorAll('[data-picker-grid]');
    for (var g = 0; g < grids.length; g++) {
      var imgs = grids[g].querySelectorAll('.bundle-deal-picker-item img');
      if (!imgs.length) continue;
      var urls = [];
      for (var i = 0; i < imgs.length; i++) {
        if (i < 12 && imgs[i].getAttribute('loading') === 'lazy') {
          imgs[i].setAttribute('loading', 'eager');
          try { imgs[i].setAttribute('fetchpriority', i < 6 ? 'high' : 'auto'); } catch (e) {}
        }
        if (i < PRELOAD_MAX) { var s = imgs[i].currentSrc || imgs[i].getAttribute('src'); if (s) urls.push(s); }
      }
      preloadUrls(urls);
    }
  }

  // ---------- Productpagina: reviews onder de prijs + koopknoppen weg bij bundel ----------
  function findDirectChild(col, pred) {
    var kids = col.children;
    for (var i = 0; i < kids.length; i++) { if (pred(kids[i])) return kids[i]; }
    return null;
  }
  function enhanceProductPage() {
    var col = document.querySelector('.product-options-form');
    if (!col || !col.querySelector('[name="add"]')) return;
    var bundle = col.querySelector('.bundle-deal-card');
    if (bundle) { document.body.classList.add('dwl-product-has-bundle'); }
    else { document.body.classList.remove('dwl-product-has-bundle'); }
    if (col.getAttribute('data-dwl-reordered') === '1') return;
    var price = col.querySelector('.product-summary__price');
    var reviews = findDirectChild(col, function (c) {
      var cls = c.className || '';
      if (/collapsible|buy-buttons|sticky-bar|__price|__title/.test(cls)) return false;
      var t = c.textContent || '';
      if (/trust\s?score|trustpilot/i.test(t)) return true;
      return (/\brating\b|\breviews?\b/i.test(t) && !!c.querySelector('img,svg,[class*="star"],[class*="trust"]'));
    });
    if (price && reviews && price.nextElementSibling !== reviews) {
      price.parentNode.insertBefore(reviews, price.nextElementSibling);
    }
    col.setAttribute('data-dwl-reordered', '1');
  }

  window.DWLCart = window.DWLCart || {};
  window.DWLCart.add = function (items, sourceEl) {
    var totalQty = items.reduce(function (s, it) { return s + (parseInt(it.quantity, 10) || 1); }, 0);
    var origin = lastPointer;
    if (sourceEl && sourceEl.getBoundingClientRect) {
      var r = sourceEl.getBoundingClientRect();
      if (r.width || r.height) origin = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    flyToCart(totalQty, origin);

    var addIds = [drawerSectionId()];
    var addMcId = mainCartSectionId();
    if (addMcId) addIds.push(addMcId);

    return _fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: addIds })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || (window.DWL_I18N && window.DWL_I18N.addFailed) || 'Add failed'); });
      return r.json();
    }).then(function (data) {
      return refreshCartUI(true, { sections: (data && data.sections) || null });
    });
  };

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';

    if (url.indexOf('?sections=') !== -1 && url.indexOf(STALE_DRAWER_SECTION) !== -1) {
      var correct = drawerSectionId();
      if (correct && correct !== STALE_DRAWER_SECTION) {
        var fixedUrl = url.split(STALE_DRAWER_SECTION).join(correct);
        return _fetch(fixedUrl, init).then(function (resp) {
          return resp.json().then(function (json) {
            var remap = {};
            Object.keys(json).forEach(function (k) { remap[k] = json[k]; });
            if (json[correct] != null) remap[STALE_DRAWER_SECTION] = json[correct];
            return new Response(JSON.stringify(remap), {
              status: resp.status,
              statusText: resp.statusText,
              headers: { 'Content-Type': 'application/json' }
            });
          });
        });
      }
    }

    var isAdd = url.indexOf('/cart/add') !== -1 && String(method).toUpperCase() === 'POST';
    if (isAdd && init && typeof init.body === 'string') {
      try {
        var parsed = JSON.parse(init.body);
        var qty = 0;
        if (parsed && parsed.items && parsed.items.length) {
          qty = parsed.items.reduce(function (s, it) { return s + (parseInt(it.quantity, 10) || 1); }, 0);
        } else if (parsed && parsed.id) {
          qty = parseInt(parsed.quantity, 10) || 1;
        }
        if (qty > 0) flyToCart(qty, lastPointer);
      } catch (e) {}
    }

    var p = _fetch.apply(this, arguments);
    if (isAdd) {
      p.then(function (r) {
        if (!(r && r.ok)) return;
        invalidateCart();
        if (_replace && _replace.keys && _replace.keys.length) {
          var keys = _replace.keys; _replace = null;
          var upd = {}; keys.forEach(function (k) { upd[k] = 0; });
          updateCart(upd).then(function () { return refreshCartUI(false); });
        } else {
          updateCartCount();
        }
      }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    lastPointer = { x: e.clientX, y: e.clientY };
  }, true);
  ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (t) {
    document.addEventListener(t, removeInterceptor, true);
  });
  document.addEventListener('click', function (e) {
    var ch = e.target && e.target.closest ? e.target.closest('.dwl-bundle-change') : null;
    if (!ch) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleChangeBundle(ch.closest('.dwl-bundle-card'));
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && (e.target.closest('.bundle-deal-modal__close') || e.target.closest('[data-modal-close]') || e.target.closest('[data-modal-overlay]') || e.target.closest('.bundle-deal-modal__overlay'))) { _replace = null; }
  }, true);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') { _replace = null; } }, true);

  var _enhanceTimer = null;
  function enhanceAll() {
    neutralizeRemoveLinks();
    revealDrawerImages();
    prettifyBundleTags();
    markBundleRows();
    groupBundles();
    stabilizeDrawer();
    enhanceEmptyCart();
    fixCountLabel();
    boostPickerImages();
    enhanceProductPage();
  }
  function scheduleEnhance() {
    if (_enhanceTimer) return;
    _enhanceTimer = setTimeout(function () { _enhanceTimer = null; enhanceAll(); }, 150);
  }

  function boot() {
    enhanceAll();
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleEnhance(); break; }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.DWLCart.refreshCartUI = refreshCartUI;
  window.DWLCart.openDrawer = openDrawer;
  window.DWLCart.closeDrawer = closeDrawer;
  window.DWLCart.markBundleRows = markBundleRows;
  window.DWLCart.drawerSectionId = drawerSectionId;
  window.DWLCart.revealDrawerImages = revealDrawerImages;
  window.DWLCart.prettifyBundleTags = prettifyBundleTags;
  window.DWLCart.groupBundles = groupBundles;
  window.DWLCart.enhanceEmptyCart = enhanceEmptyCart;
})();